/**
 * @remix-run/css-bundle v1.19.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
// Injected by `cssBundlePlugin`
let cssBundleHref = typeof undefined === "string" ? undefined : undefined;

export { cssBundleHref };
